import { QueryBuilderTokenType } from '../../../../types';

export const getActiveEntityTokenIndex = (
  tokens: QueryBuilderTokenType[],
  valueEditTokenIndex: number | null
): number | null => {
  if (valueEditTokenIndex !== null) {
    const token = tokens[valueEditTokenIndex];

    if (token?.type === 'entity') {
      return valueEditTokenIndex;
    }
  }

  const lastIndex = tokens.length - 1;

  if (tokens[lastIndex]?.type === 'entity') {
    return lastIndex;
  }

  return null;
};
